import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.159 3.985a2.25 2.25 0 0 1 2.229 1.941l.382 2.754 1.215-.364.075-.018a.75.75 0 0 1 .429 1.429l-.072.026-.485.145a2.74 2.74 0 0 1 1.019 2.137v7.5a1.25 1.25 0 0 1-1.25 1.25h-2.2a1.25 1.25 0 0 1-.5-.104 1.2 1.2 0 0 1-.5.104h-2.2a1.25 1.25 0 0 1-1.25-1.25v-2.55h-4.2v2.55a1.25 1.25 0 0 1-1.25 1.25H6.4c-.179 0-.348-.038-.502-.105a1.2 1.2 0 0 1-.498.105H3.2a1.25 1.25 0 0 1-1.25-1.25v-7.5c0-.875.41-1.654 1.047-2.157l-.413-.124-.072-.026a.75.75 0 0 1 .429-1.429l.075.018 1.214.364.382-2.754A2.25 2.25 0 0 1 6.84 3.985zM3.45 19.285h1.7v-2.3h-1.7zm3.2 0h1.7v-2.3h-1.7zm8.899 0h1.7v-2.3h-1.7zm3.2 0h1.7v-2.3h-1.7zm-14.05-8.5a1.25 1.25 0 0 0-1.25 1.25v3.45h17v-3.45a1.25 1.25 0 0 0-1.25-1.25zm2.14-5.3a.75.75 0 0 0-.742.647L5.66 9.285h12.679l-.437-3.152a.75.75 0 0 0-.743-.647z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const DualRearWheelsIcon = ForwardRef;